import { lazy, Suspense } from 'react'

import { defineMessages } from 'react-intl'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import { expenseReportConfig } from '@webapp/modules/reports/config/reportConfigs'

const ReportAggregateViewChunk = lazy(() =>
  import('../../feature-sets/ReportAggregateView').then(
    ({ ReportAggregateView }) => ({
      default: ReportAggregateView,
    })
  )
)

const scope = `procurify.modules.reports.pages.ExpensesBySecondaryCategoryReportPage`

const messages = defineMessages({
  // UI copy keeps "department" per ADR-7 — code names use SecondaryCategory.
  pageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Expenses by department',
  },
})

export const ExpensesBySecondaryCategoryReportPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.pageTitle)}
      breadcrumbs={[{ name: intl.formatMessage(messages.pageTitle) }]}
    >
      <div data-testid='expenses-by-secondary-category-report-page'>
        <Suspense fallback={null}>
          <ReportAggregateViewChunk reportConfig={expenseReportConfig} />
        </Suspense>
      </div>
    </Page>
  )
}
